import { memo, useCallback } from 'react';
import { NodeResizer, useReactFlow } from 'reactflow';

export default memo(({ id, data, selected }: any) => {
    const { setNodes } = useReactFlow();

    const onChange = useCallback((evt: any) => {
        const val = evt.target.value;
        setNodes((nds) => nds.map((n) => {
            if (n.id === id) {
                // Preserve data, update label
                return { ...n, data: { ...n.data, label: val } };
            }
            return n;
        }));
    }, [id, setNodes]);

    return (
        <div className="h-full w-full relative group min-w-[100px] min-h-[30px] flex flex-col bg-yellow-50/50 rounded border border-transparent hover:border-slate-300 focus-within:border-yellow-300 focus-within:ring-2 focus-within:ring-yellow-400/20 transition-all shadow-sm">
            {/* Drag Handle Bar */}
            <div className="h-3 w-full bg-yellow-100/50 rounded-t cursor-grab active:cursor-grabbing hover:bg-yellow-200/50 transition-colors" title="Drag to move" />

            {/* Direct Editable Text Area */}
            <textarea
                className="nodrag nowheel w-full flex-1 p-2 bg-transparent border-0 resize-none focus:outline-none font-mono leading-relaxed text-slate-600 placeholder:text-slate-300"
                value={data.label || ''}
                onChange={onChange}
                placeholder="Type comment..."
                style={{
                    fontSize: '8px', // Default small font as requested
                    whiteSpace: 'pre-wrap'
                }}
            />

            <NodeResizer
                color="#94a3b8"
                isVisible={selected}
                minWidth={100}
                minHeight={30}
                handleStyle={{ width: 8, height: 8, borderRadius: 2 }}
            />
        </div>
    );
});
